import { createTheme } from "@mui/material/styles";
import { red } from "@mui/material/colors";
export const Colors = {
    AZUL_GOV: "#034EA2",
    AMARELO_GOV: "#FDB913",
    VERMELHO_GOV: "#EF4123",
    VERDE_GOV: "#007932",
};
export const theme = createTheme({
    palette: {
        primary: {
            main: Colors.AZUL_GOV,
        },
        secondary: {
            main: "#19857b",
        },
        error: {
            main: red.A400,
        },
    },
    typography: {
        fontFamily: [
            "Montserrat",
            "-apple-system",
            "BlinkMacSystemFont",
            '"Segoe UI"',
            "Roboto",
            '"Helvetica Neue"',
            "Arial",
            "sans-serif",
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(","),
    },
    components: {
        MuiPaper: {
            styleOverrides: {
                // Name of the slot
                root: {
                    borderRadius: "14px",
                    background: "#FFFFFF",
                    borderWidth: 1,
                    borderColor: "#ECEEF4",
                    boxShadow: "none",
                },
            },
        },
    },
});
export const toSlug = (text) => {
    return text
        .normalize("NFD") // separa letras de acentos
        .replace(/[\u0300-\u036f]/g, "") // remove acentos
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9\s-]/g, "") // remove caracteres especiais
        .replace(/\s+/g, "-") // troca espaços por hífens
        .replace(/-+/g, "-"); // remove hífens duplicados
};
export const formatarData = (data) => {
    const d = new Date(data);
    if (isNaN(d.getTime()))
        return "Data inválida";
    return d.toLocaleDateString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
    });
};
export const estoques = [
    {
        tipo: "a_negativo",
        label: "A-",
        level: 0,
        quantidade: 0,
    },
    {
        tipo: "a_positivo",
        label: "A+",
        level: 0,
        quantidade: 0,
    },
    {
        tipo: "ab_negativo",
        label: "AB-",
        level: 0,
        quantidade: 0,
    },
    {
        tipo: "b_negativo",
        label: "B-",
        level: 0,
        quantidade: 0,
    },
    {
        tipo: "b_positivo",
        label: "B+",
        level: 0,
        quantidade: 0,
    },
    {
        tipo: "ab_positivo",
        label: "AB+",
        level: 0,
        quantidade: 0,
    },
    {
        tipo: "o_negativo",
        label: "O-",
        level: 0,
        quantidade: 0,
    },
    {
        tipo: "o_positivo",
        label: "O+",
        level: 0,
        quantidade: 0,
    },
];
